import { IFormElementConfig } from '@core/interfaces/form.interface';


export interface IFormElementsConfig {
	textArea: IFormElementConfig;
}

export const FORM_ELEMENTS_DEFAULT_CONFIG: IFormElementsConfig = {
	textArea: {
		maxLength: 500
	}
};
